import React from 'react';

function Seven() {
    return (
        <div className="blog-post">
            <h1>The Eternal Promise, The Training Data Paradox, and AI Myths</h1>
            <small>03-08-2026</small>
            <p>
                This week's blog covers two articles by Ivan Turkovic:{' '}
                <a href='https://blog.coding.al/the-eternal-promise/' target='_blank' rel='noopener noreferrer'>The Eternal Promise: A History of Attempts to Eliminate Programmers</a> and{' '}
                <a href='https://blog.coding.al/the-training-data-paradox/' target='_blank' rel='noopener noreferrer'>The Training Data Paradox: What Happens When AI Replaces the Engineers Who Trained It</a>.
                I'll also be arguing against three common claims about AI and wrapping up with an update on my Nogramming assignment.
            </p>
            <br />
            <h2>Arguing Against Three AI Claims</h2>
            <h4>Claim 1</h4>
            <p>
                "People that use AI to answer their questions are uneducated and unwise"
            </p>
            <p>
                To me, there is truth to part of this statement. If you're using AI for an extensive amount of research, then 
                you'll definitely run into a lot of errors and some likely false information. An aspect of using AI that some people 
                don't consider is the aspect of speed. AI is much faster than searching google and reading through sources. If 
                you have questions about in depth topics, then AI is not the way to go. However, if you're looking for simple answers 
                to simple questions, then AI is definitely a useful tool. The most important thing is to check behind the AI, when 
                you come across an answer or a question that doesn't seem very simple.
            </p>
            <h4>Claim 2</h4>
            <p>
                "AI can only make the job market worse."
            </p>
            <p>
                Right now, AI is one factor that's contributing to a bad job market. However, I like to compare it to other 
                periods of history where technology is growing. For example, when factories became automated, factory workers lost most of their jobs. 
                What happened after that though? Other jobs opened up. I can't imagine that corporations and monopolized businesses won't find 
                a need for workers. In one way or another, jobs will open, creating new fields for laid off employees to enter.
            </p>
            <br />
            <h4>Claim 3</h4>
            <p>
                "AI is a negative tool for learning."
            </p>
            <p>
                To me, AI can have a negative affect on someones learning if they're using it to do their work for them. 
                However, AI is a tool that can be used to accelerate your learning, only if you're able to take advantage 
                of the information that AI gives you. The way that AI is built allows it to be a huge pool of data/information. 
                You have that information at your fingertips for free. If you can't find a way to use that tool to your advantage, 
                then you're the one who is stunting your own learning.
            </p>
            <br />
            <h2>Nogramming Assignment Progress</h2>
            <p>
                This week, I'll begin planning the materials and resources needed to build the piece of an LLM by hand. Then I will buy some of the materials.
            </p>
        </div>
    );
}

export default Seven;
